<template>
  <div class="pay-record">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <div @click="payInfo(item)" class="record-d" v-for="(item,index) in recordList" :key="index">
          <div :style="selectColor(item.orderStatus)" class="orderStatus">{{item.orderStatusName}}</div>
          <div class="public-sty1">订单号：{{item.orderNo}}</div>
          <div class="public-sty">
            <div>缴费时间：{{item.payTime}}</div>
            <div class="public-t">项目：{{item.seatTypeName}}</div>
          </div>
          <div class="public-sty">
            <div>缴费金额：{{item.amount}}元</div>
            <div class="public-t">支付押金：{{item.depositMonths >=1 ? '是' : '否'}}</div>
          </div>
          <!-- <div class="public-sty">缴费方式：{{item.payName}}</div> -->
          <div class="public-sty">
            <div>缴费方式：{{item.payName}}</div>
            <div class="public-t">单价：{{item.price}}元/月</div>
          </div>
          <div class="public-sty">
            <div>租赁电脑个数：{{item.computerNum}}</div>
            <div class="public-t">座位号：{{item.seatNo}}</div>
          </div>
          <div class="public-sty">
            <div>计费日期：{{item.startDate}}</div>
            <div class="public-t">到期日期：{{item.endDate}}</div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import URL from "@/api/kingWaiter";
import { Toast } from "vant";
import { jspay2 } from '@/utils/utils';
export default {
  data() {
    return {
      recordList: [],
      page: 0,
      size: 10,
      total: 0,
      loading: false,
      finished: false,
      refreshing: false,
      orderStatus: ["0","1","2","3"]
    }
  },
  methods: {
    onLoad() {
      this.paymentRecord()
    },
    payInfo(item) {
      if (item.orderStatus === '0' || item.orderStatus === '2') {
        // let data = {
        //   openid: localStorage.getItem("openid"),
        //   phone: localStorage.getItem("phone"),
        //   ip: localStorage.getItem('cip'),
        //   money: (item.amount * 100),
        //   orderId: item.orderNo
        // }
        // jspay2(data)
        this.$router.push({ path: "/tobePay", query: {amount: item.amount, orderNo: item.orderNo}});
      } else if (item.orderStatus === '4') {
        Toast('订单号正在支付中，请稍候')
      } else if (item.orderStatus === '3') {
        Toast('该订单已失效，请联系管理员重新创建！')
      }
    },
    onRefresh() {
      this.recordList = []
      this.page = 0
      this.finished = false;
      this.loading = true;
      this.paymentRecord()
    },
    selectColor(value) {
      if (value === '0') {
        return {'background': 'yellow'}
      } else if (value === '1') {
        return {'background': 'green'}
      } else if (value === '2') {
        return {'background': 'red'}
      } else if (value === '3') {
        return {'background': 'gray'}
      }
    },
    // 缴费记录
    paymentRecord() {
        let that=this
      let data = {
        phoneNo: localStorage.getItem("phone"),//用户手机号
        page: this.page,
        size: this.size
      }
      this.$fetchGet(URL.payRecord.url, data).then(res => {
        if (res.data.code == 20000) {
          let list = res.data.data.records
          that.total = res.data.data.total
          that.refreshing = false;
          that.loading = false;
          if (list == null || list.length == 0) {
            that.finished = true;
            return
          }
          if (that.page > 1) {
            that.recordList = [...that.recordList, ...list]
          } else {
            that.recordList = list
          }
          if (that.recordList.length >= that.total) {
            that.finished = true
            return
          }

          if (that.recordList.length < that.total) {
            that.page++
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.pay-record {
  .record-d {
    width: 355px;
    height: 150px;
    margin: 15px auto auto;
    background: url("./img/bg.png") no-repeat 100%;
    background-size: 100% 100%;
    .public-sty {
      height: 11px;
      line-height: 11px;
      display: flex;
      padding: 10px 0 0 18px;
      font-size: 11px;
      color: #333333;
      div {
        &:first-child {
          width: 180px;
        }
      }
      &:first-child {
        padding-top: 15px;
      }
    }
    .public-sty1 {
      height: 11px;
      line-height: 11px;
      display: flex;
      padding: 0 0 0 18px;
      font-size: 11px;
      color: #333333;
    div {
    &:first-child {
       width: 180px;
     }
    }
    &:first-child {
       padding-top: 15px;
     }
    }
    .orderStatus {
      position: relative;
      top: 4px;
      left: 85%;
      width: 46px;
      font-size: 10px;
      margin-top: 0;
      border:1px solid #000;
      color: black;
      text-align: center;
    }
  }
}
</style>